import { EstimateErrorDetails } from 'common/models/databaseSync/syncNotification';
import { FC } from 'react';
import { EstimateErrorTable } from './EstimateErrorTable';
import { ErrorMessage, SyncErrorsWrapper } from './styles';

export const SyncErrorsDetails: FC<{
  syncEstimateErrors?: EstimateErrorDetails[];
  syncErrorMessage?: string;
  taskDetailsPresent?: boolean;
}> = ({ syncErrorMessage, syncEstimateErrors, taskDetailsPresent }) => {
  const hasSyncErrors = !!syncEstimateErrors?.length;

  return hasSyncErrors || syncErrorMessage ? (
    <SyncErrorsWrapper>
      {hasSyncErrors && (
        <>
          <hr />
          <EstimateErrorTable estimateErrors={syncEstimateErrors} />
        </>
      )}
      {syncErrorMessage && (
        <>
          <hr />
          <p style={{ marginBottom: 0 }}>
            {taskDetailsPresent ? 'Additionally, there ' : 'There '}
            was a general problem during the synchronization process. The
            details below can help technical support resolve the issue:
          </p>
          <ErrorMessage>{syncErrorMessage}</ErrorMessage>
        </>
      )}
    </SyncErrorsWrapper>
  ) : (
    <></>
  );
};
